/**
 * Created by Simon Zhao on 7/19/2019.
 * Description:
 * MDL template edit button
 * ------ maintenance history ------
 */

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MdlDialogOpenOptions } from '../../../mdl-dialog/mdl-dialog.model';
import { MdlDialogService } from '../../../mdl-dialog/mdl-dialog.service';
import { SaveScreenDialogService } from '../../../save-screen-dialog/save-screen-dialog.service';
import { AdminTemplateSettingItem } from './admin-template-settings.model';
@Component({
    selector: 'tam-admin-template-edit-button',
    template: `
    <div kendoTooltip position="bottom" class='edit-button'>
        <smart-icon #anchor name='pencil' class='smart-icon light' (click)='clicked($event)' title="Edit">
        </smart-icon>
    </div>`,
    styleUrls: ['./admin-template-settings.component.scss']
})
export class AdminTemplateEditButtonComponent implements ICellRendererAngularComp {
    private _params: { data: AdminTemplateSettingItem };
    constructor(
        private _mdlDialogService: MdlDialogService
    ) { }

    agInit(params: { data: AdminTemplateSettingItem }): void {
        this._params = params;
    }

    clicked(args: MouseEvent): void {
        const mdlDialogOpenOptions = new MdlDialogOpenOptions();
        mdlDialogOpenOptions.templateItem = this._params.data;
        this._mdlDialogService.dialogOpen$.next(mdlDialogOpenOptions);
    }

    refresh(): boolean {
        return false;
    }

}
